<template>
  <div class="container py-5">

    <div class="columns is-multiline" v-if="!loading">

      <div class="column is-full">
        <div class="title is-4 mr-3 ml-1">
          Work Steps
        </div>
      </div>

      <div class="column">
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <!-- <th>
                <v-checkbox 
                  :value="allSelected" 
                  @input="toggleAllSelected($event)"/>
              </th> -->
              <th 
                class="text--nowrap"
                v-for="(header, headerIndex) in headers" 
                :key="headerIndex">
                {{ header.label }}
              </th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr 
              class="v-centered"
              v-for="step in workSteps"
              :key="step.id">

              <!-- <td>
                <v-checkbox 
                  :value="selected.includes(step.id)" 
                  @input="toggleSelected(step.id)"/>
              </td> -->

              <td>
                <v-text-field
                  v-if="step.id == editingId"
                  required
                  placeholder="Step Name"
                  v-model="step.work_name"/>
                <span v-else>
                  {{ step.work_name }}
                </span>
              </td>

              <td>
                <v-text-field
                  v-if="step.id == editingId"
                  required
                  placeholder="Step Description"
                  v-model="step.work_desc"/>
                <span v-else>
                  {{ step.work_desc }}
                </span>
              </td>

              <td>
                <v-select
                  v-if="step.id == editingId"
                  required
                  :options="workSteps.filter(d => d.id != step.id)"
                  item-text="work_name"
                  item-value="id"
                  v-model="step.previous_step"
                />
                <span v-else>
                  {{ getWorkStep(step.previous_step) }}
                </span>
              </td>

              <td>
                <v-select
                  v-if="step.id == editingId"
                  required
                  :options="workSteps.filter(d => d.id != step.id)"
                  item-text="work_name"
                  item-value="id"
                  v-model="step.next_step"
                />
                <span v-else>
                  {{ getWorkStep(step.next_step) }}
                </span>
              </td>

              <td>
                {{ step.workstation_steps.length }}
              </td>
  
              <td>
                <v-text-field
                  v-if="step.id == editingId"
                  required
                  type="number"
                  placeholder="Hours of Work Required per Linear Ft"
                  v-model="step.linear_ft_hour"
                />
                <span v-else>
                  {{ step.linear_ft_hour }}
                </span>
              </td>

              <td>
                <div class="buttons buttons-right">
                  <template v-if="editingId != step.id">
                    <button
                      @click.stop="editingId = step.id" 
                      class="button is-small is-primary">
                      <span class="icon">
                        <i class="fas fa-edit"></i>
                      </span>
                      <span>Edit</span>
                    </button>
                    <!-- <button
                      @click.stop="launchConfirmDelete(step.id)" 
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-trash has-text-grey"></i>
                      </span>
                      <span>Delete</span>
                    </button> -->
                  </template>
                  <template v-else>
                    <button
                      @click.stop="save(step)"
                      class="button is-small is-primary">
                      <span class="icon">
                        <i class="fas fa-save"></i>
                      </span>
                      <span>Save</span>
                    </button>
                    <button
                      @click.stop="editingId = null" 
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-times has-text-grey"></i>
                      </span>
                      <span>Exit Editing</span>
                    </button>
                  </template>
                </div>
              </td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>

  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'
import VConfirmModal from '@/components/base/VConfirmModal'
import VPagination from '@/components/base/VPagination'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VConfirmModal, 
    VPagination, 
    VTextField,
    VSelect
  },
  data() {
    return {
      headers: [
        { label: 'Work Step Name' },
        { label: 'Work Description' },
        { label: 'Previous Work Step' },
        { label: 'Next Work Step' },
        { label: 'Number of Work Stations'},
        { label: '# of Hours Needed per Linear Ft' }
      ],
      adding: false,
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this installation?',
        type: 'danger'
      },
      deleteConfirmedCb: null,
      editingId: null,
      managingInstallationTypes: false
    }
  },
  computed: {
    ...mapState("workSteps", [
      "workSteps", "loading", "pagination", "allSelected", "selected"
    ])
  },
  watch: {
    'pagination.page'(page) {
      this.getWorkSteps({ page: page });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("workSteps", [
      "getWorkSteps", "updateWorkStep", "deleteWorkStep"
    ]),
    ...mapMutations("workSteps", ["changePage"]),
    initialize() {
      this.getWorkSteps();
    },
    save(step) {
      let saveFields = [
        'work_name', 'work_desc', 'previous_step', 'next_step', 'linear_ft_hour'
      ]

      let payload = {}
      saveFields.forEach(field => payload[field] = step[field]);

      this.updateWorkStep({
        workStepId: step.id,
        data: payload
      }).then(() => this.editingId = null)
    },
    getWorkStep(id) {
      if (id) {
        return this.workSteps.filter(d => d.id == id)[0].work_name
      } else {
        return ''
      }
    },
    launchConfirmDelete(id) {
      if (!id) {
        this.deleteConfirmedCb = () => {
          this.selected.forEach(id => {
            this.deleteWorkStep(id);
            this.confirmDelete.state = false;
          })
        }
        this.confirmDelete.message = `Are you sure you want to delete the ${this.selected.length} work step?`;
        this.confirmDelete.state = true;
      } else {
        this.deleteConfirmedCb = () => {
          this.deleteWorkStep(id);
          this.confirmDelete.state = false;
        }
        this.confirmDelete.message = 'Are you sure you want to delete this work step?';
        this.confirmDelete.state = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/flexbox.scss';
</style>